import { render } from "./IconSortUp.vue?vue&type=template&id=5dea8977"
import script from "./IconSortUp.vue?vue&type=script&lang=js"
export * from "./IconSortUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconSortUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5dea8977"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5dea8977', __exports__)) {
    api.reload('5dea8977', __exports__)
  }
  
  module.hot.accept("./IconSortUp.vue?vue&type=template&id=5dea8977", () => {
    api.rerender('5dea8977', render)
  })

}


export default __exports__